<template>
	<div>
		<form>
		  <h2>{{ $t("info.title") }}</h2>
		    <hr>
		    <div class="form-row">
		      <div class="col">
		        <label>{{ $t("info.firstName") }} *</label>
            <input name="firstName" v-validate="'required'" v-model.trim="firstName" type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.has('firstName')}" autofocus>
		      </div>
		      <div class="col">
		        <label>{{ $t("info.lastName") }} *</label>
		        <input name="lastName" v-validate="'required'" v-model.trim="lastName" type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.has('lastName')}">
		      </div>
		    </div>
		    <div class="form-row">
		      <div class="col">
		        <label>{{ $t("info.mail") }} *</label>
            <input
              name="email"
              v-validate="'required|email'"
              v-model.trim="email"
              type="email"
              class="form-control form-control-sm"
              :class="{'is-invalid': errors.has('email')}"
              >
		      </div>
		      <div class="col">
		        <label>{{ $t("info.phone") }} *</label>
            <VuePhoneNumberInput name="phone" v-validate="'required'" type="text" :class="{'is-invalid': errors.has('phone')}" size="sm" required @update="updatePhone" clearable :no-example="true" v-model="phoneInput" :border-radius="0" :countries-height="40" ref="phoneInputRef" :default-country-code="phoneDataInfo.countryCode" :preferred-countries="preferredCountries" />
		      </div>


		    </div>
		    <div v-if="tripType === AirportPlace || (form.tripType === 'roundTrip' && tripType !== PlacePlace)">
		      <hr>
		      <h5><strong>{{ $t("info.arrivalInfo") }}</strong></h5>
		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.date") }} *</label>
              <datepicker
                name="arrivalDate"
                v-validate="'required'"
                :disabledDates="disabledDates"
                v-model="arrivalDate"
                onkeypress="return false;"
                key="arrivaldate"
                :input-class="['form-control', 'form-control-sm', {'is-invalid': errors.has('arrivalDate')}]"
                :typeable="false"
                >
              </datepicker>
		        </div>
		        <div class="col">
		          <div class="row no-gutters">
		            <div class="col-5">
		              <label>{{ $t("info.hour") }} *</label>
		              <select name="arrivalHours" v-validate="'required'" v-model="arrivalHours" class="form-control form-control-sm" :class="{'is-invalid': errors.has('arrivalHours')}">
                    <!-- <option value=""></option> -->
                    <option :key="'arrival-hour'+i" v-for="i in 24" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
                <div class="col-1 fix-time-points">
                  <strong>:</strong>
                </div>
		            <div class="col-5">
		              <label>{{ $t("info.minutes") }} *</label>
		              <select name="arrivalMinutes" v-validate="'required'" v-model="arrivalMinutes" class="form-control form-control-sm"  :class="{'is-invalid': errors.has('arrivalMinutes')}">
                    <!-- <option value=""></option> -->
		                <option :key="'arrival-minutes'+i" v-for="i in 60" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
		          </div>
		        </div>
		      </div>
		      <small><strong>{{ $t("info.labelFlight") }}</strong></small>
		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.flight") }} *</label>
		          <input name="arrivalFligthNumber" v-validate="'required'" v-model="arrivalFligthNumber" type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.has('arrivalFligthNumber')}">
		        </div>
		        <div class="col">
		          <label>{{ $t("info.airline") }} *</label>
		          <input name="arrivalAirline" v-validate="'required'" v-model="arrivalAirline" type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.has('arrivalAirline')}">
		        </div>
		      </div>
		    </div>
		    <div v-if="tripType === PlaceAirport || (form.tripType === 'roundTrip' && tripType !== PlacePlace)">
		      <hr>
		      <h5>
            <strong>{{ $t("info.departureInfo") }}</strong>
            <br>
          </h5>
          <span style="display:block;line-height:14px;font-size:14px;">
              {{ $t("info.departureLabel") }}
              <!-- <button :disabled="!(canCalcPickUpDate)" @click="pickupDateEdits = !pickupDateEdits" type="button" class="btn btn-sm btn-primary">I want to change my PickUp time</button> -->
          </span>
          <br>
		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.flightDate") }} *</label>
              <datepicker name="departureDate" v-validate="'required'" :disabledDates="disabledDates"  v-model="departureDate" :typeable="false" onkeypress="return false;" key="departure-date" :input-class="['form-control', 'form-control-sm', {'is-invalid': errors.has('departureDate')}]" @selected="calcPickUpDateEnque()" ></datepicker>
		        </div>
		        <div class="col">
		          <div class="row no-gutters">
		            <div class="col">
		              <label> {{ $t("info.hour") }} *</label>
		              <select name="departureHours" v-validate="'required'" v-model="departureHours" class="form-control form-control-sm" :class="{'is-invalid': errors.has('departureHours')}" @change="calcPickUpDate()">
                    <option :key="'departure-hour'+i" v-for="i in 24" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
                <div class="col-1 fix-time-points">
                  <strong>:</strong>
                </div>
                <div class="col">
		              <label> {{ $t("info.minutes") }} *</label>
		              <select name="departureMinutes" v-validate="'required'" v-model="departureMinutes" class="form-control form-control-sm" :class="{'is-invalid': errors.has('departureMinutes')}" @change="calcPickUpDate()">
		                <option :key="'departure-minutes'+i" v-for="i in 60" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
		          </div>
		        </div>
		      </div>

          <div class="progress" v-if="loadingPickupDate">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
          </div>

		      <div class="form-row" v-else>
            <!-- <div class="col col-12">
              <small>
                <strong> I want to change my PickUp </strong>
              </small>
              <button :disabled="!(canCalcPickUpDate)" @click="pickupDateEdits = !pickupDateEdits" type="button" class="btn btn-sm btn-primary">Change</button>
            </div> -->
		        <div class="col">
		          <label>{{ $t("info.pickUpDate") }} *</label>
              <datepicker name="pickUpDate" v-validate="'required'" v-model="pickUpDate" :typeable="false" onkeypress="return false;" key="pickup-date" :input-class="['form-control', 'form-control-sm', {'is-invalid': errors.has('pickUpDate')}]" ></datepicker>
		        </div>
		        <div class="col">
		          <div class="row no-gutters">
		            <div class="col">
                  <label> {{ $t("info.hour") }} *</label>
		              <select name="pickUpHours" v-validate="'required'" v-model="pickUpHours" class="form-control form-control-sm" :class="{'is-invalid': errors.has('pickUpHours')}" >
                    <option :key="'pickcUp-hour'+i" v-for="i in 24" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
                <div class="col-1 fix-time-points">
                  <strong>:</strong>
                </div>
                <div class="col">
		              <label> {{ $t("info.minutes") }} *</label>
		              <select name="pickUpMinutes" v-validate="'required'" v-model="pickUpMinutes" class="form-control form-control-sm" :class="{'is-invalid': errors.has('pickUpMinutes')}" >
		                <option :key="'pickup-minutes'+i" v-for="i in 60" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
		          </div>
		        </div>
		      </div>

		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.flight") }} *</label>
		          <input name="departureFlightNumber" v-validate="'required'" v-model.trim="departureFlightNumber" type="text" class="form-control form-control-sm"  :class="{'is-invalid': errors.has('departureFlightNumber')}">
		        </div>
		        <div class="col">
		          <label>{{ $t("info.airline") }} *</label>
		          <input name="departureAirline" v-validate="'required'" v-model.trim="departureAirline" type="text" class="form-control form-control-sm" :class="{'is-invalid': errors.has('departureAirline')}">
		        </div>
		      </div>
		    </div>
		    <div v-if="tripType === PlacePlace">
		      <hr>
		      <h5><strong>{{fromPlace.description}} - <span class="text-primary">Pick Up</span></strong></h5>
		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.date") }} *</label>
              <datepicker name="originDate" v-validate="'required'" :disabledDates="disabledDates"  v-model="originDate" :typeable="false" onkeypress="return false;" key="origin-date" :input-class="['form-control', 'form-control-sm', {'is-invalid': errors.has('originDate')}]"></datepicker>
		        </div>
		        <div class="col">
		          <div class="row no-gutters">
		            <div class="col">
		              <label>{{ $t("info.hour") }} *</label>
		              <select name="originHours" v-validate="'required'" v-model="originHours" class="form-control form-control-sm" :class="{'is-invalid': errors.has('originHours')}">
                    <option value=""></option>
                    <option :key="'origin-hour'+i" v-for="i in 24" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
                <div class="col-1 fix-time-points">
                  <strong>:</strong>
                </div>
		            <div class="col">
		              <label>{{ $t("info.minutes") }} *</label>
		              <select name="originMinutes" v-validate="'required'" v-model="originMinutes" class="form-control form-control-sm" :class="{'is-invalid': errors.has('originMinutes')}">
                    <option value=""></option>
		                <option :key="'origin-minutes'+i" v-for="i in 60" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		    <div v-if="tripType === PlacePlace && form.tripType === 'roundTrip'">
		      <hr>
		      <h5><strong>{{toPlace.description}} - <span class="text-primary">{{ $t("info.dropOff") }}</span></strong></h5>
		      <div class="form-row">
		        <div class="col">
		          <label>{{ $t("info.date") }} *</label>
              <datepicker name="destinationDate" v-validate="'required'" :disabledDates="disabledDates" v-model="destinationDate" :typeable="false" onkeypress="return false;" key="destination-date"  :input-class="['form-control', 'form-control-sm', {'is-invalid': errors.has('destinationDate')}]"></datepicker>
		        </div>
		        <div class="col">
		          <div class="row no-gutters">
		            <div class="col">
		              <label>{{ $t("info.hour") }} *</label>
		              <select name="destinationHours" v-validate="'required'" v-model="destinationHours" class="form-control form-control-sm" :class="{'is-invalid': errors.has('destinationHours')}">
                    <option value=""></option>
                    <option :key="'destination-hour'+i" v-for="i in 24" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
                <div class="col-1 fix-time-points">
                  <strong>:</strong>
                </div>
		            <div class="col">
		              <label>{{ $t("info.minutes") }} *</label>
		              <select name="destinationMinutes" v-validate="'required'" v-model="destinationMinutes" class="form-control form-control-sm"  :class="{'is-invalid': errors.has('destinationMinutes')}" >
                    <option value=""></option>
		                <option :key="'destination-minutes'+i" v-for="i in 60" :value="i-1">{{i<=10?'0'+(i-1):i-1}}</option>
		              </select>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		    <hr>
		    <h5>{{ $t("info.notes") }}</h5>
		    <div class="form-group">
		      <textarea v-model="notes" class="form-control"></textarea>
		    </div>
		    <hr>
		  <br>
      <Navigation :prevRun="prevRun"></Navigation>
		</form>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import {mapStateInfo, mapStateInfoVal, mapMutationsInfo, dynamicFormSetGet} from '../js/InformationStoreInfo.js'
import {TripTypes} from '../js/constants.js'
import Datepicker from 'vuejs-datepicker';
import Navigation from './Navigation.vue'
import Utils from '../js/Utils'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

const validateEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'Info',
  components: {
    Datepicker,
    Navigation,
    VuePhoneNumberInput
  },
  data: () => {
  	return {
      preferredCountries: ['CA', 'MX', 'US'],
      phoneInput: '',
      forceNoFocus: true,
      loading: true,
      prices: {},
      paymentMethods : {
        'paypal':'PayPal',
        'at-arrival':'At Arrival',
        'card':'Credit/Debit Card'
      },
      pickupDateEdits: false,
      loadingPickupDate: false,
      ...TripTypes,
  	}
  },
  computed: {
    ...mapGetters(['companyDisabledDates']),
    ...mapState(mapStateInfo),
    ...mapState(mapStateInfoVal),
    ...dynamicFormSetGet(),
    phoneDataInfo: {
      get() {
        this.phoneInput = this.phoneData.phoneNumber;
        return this.phoneData;
      }
    },
    disabledDates: {
      get() {
        const now = new Date();
        const y = now.getFullYear();
        const m = now.getMonth();
        const d = now.getDate();
        if (this.hasSetting) {
          const min = new Date(y, m , d+ parseInt(this.settings.prevDaysToReservation));
          return {
            to: min,
            dates: this.companyDisabledDates
          }
        }
      }
    },
    canCalcPickUpDate() {
      return this.departureDate !== null && this.departureHours !== null && this.departureMinutes !== null;
    }
  },
  mounted() {
    /*
    this.formatFormExtras();
    this.$http.post('prices/totals', {...this.form}, {emulateJSON: true})
      .then((res) => {
        this.loading = false;
        this.prices = res.body;
      });
    */
  },
  methods: {
    ...mapMutations(mapMutationsInfo),
    ...mapActions(['formatFormExtras']),
    prevRun() {
        return this.$validator.validate().then((valid) => {
          if (!valid) {
            let errorsText = this.errors.all().join("<br>");
            this.$alertify.alert("Required fileds", errorsText);
            return Promise.reject();
          }
        });
    },
    formateDatetime: Utils.formateDatetime.bind(Utils),
    calcPickUpDate() {
      var placeId;
      if (this.tripType === TripTypes.PlaceAirport) {
        placeId = this.fromPlace.placeId;
      } else if (this.tripType === TripTypes.AirportPlace) {
        placeId = this.toPlace.placeId;
      }

      if (this.canCalcPickUpDate && placeId) {
        this.loadingPickupDate = true;
        var date = this.formateDatetime(this.departureDate, this.departureHours, this.departureMinutes);
        this.$http.get("places/pickup", {params: {placeId, date}}).then((res) => {
          if (res.body.year) {
            this.pickUpDate = new Date(res.body.year, res.body.month-1, res.body.day);
            this.pickUpHours = res.body.hours;
            this.pickUpMinutes = res.body.minutes;
          }
        });
        setTimeout(() => {this.loadingPickupDate = false}, 300);
      }
    },
    calcPickUpDateEnque() {
      Vue.nextTick(this.calcPickUpDate);
    },
    updatePhone(data) {
      this.phone = data.formattedNumber;
      this.$store.commit("phoneData", data);
      if (this.forceNoFocus && document.activeElement && document.activeElement.blur) {
        this.forceNoFocus = false;
        Vue.nextTick(() => {
          document.activeElement.blur();
        });
      }
    }
  }
}
</script>
<style>
  .vdp-datepicker input{
    background-color: #fff !important;
  }
  .select-country-container{
    width: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
  }
  .select-country-container label {
    font-size: 7px !important;
  }
  .vue-phone-number-input input {
    border-radius: 0.2rem !important;
    height: calc(1.7em + 0.5rem + 2px) !important;
    min-height: calc(1.7em + 0.5rem + 2px) !important;
  }
  .vue-phone-number-input .input-phone-number label{
    display: none;
  }
  .vue-phone-number-input #VuePhoneNumberInput_phone_number{
    padding-top: 0 !important;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-selection input{
    visibility: visible !important;
    bottom:3px;
    right:3px;
  }
  .fix-time-points{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top:20px;
  }
	.btn-selection button.btn{
		flex-direction:column;
		white-space: inherit;
	}
	.btn-selection button i.p-logo{
		font-weight: normal;
	}
	.summary .row > div{
		margin-bottom:0;
	}
	small{
		position: relative;
		top: -7px;
	}
	.form-row{
		margin-bottom: 5px;
	}
	label{
		margin-bottom: 0;
	}

  .btn-force-danger{
    border-color: #dc3545 !important;
  }
    .btn-selection button.active svg.check{
    display: block;
  }
  .btn-selection button svg.check{
    display:none;
    position: absolute;
    top: 5px;
    right:5px;
    border-radius: 100%;
    padding: 2px;
  }
  .btn-selection button.active{
    width: 32%;
    height: 100px;
  }
  .btn-selection{
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .btn-selection button input{
    visibility: hidden;
    position: absolute;
  }
  .btn-selection button{
    border-width: 3px;
    border-style: solid;
    /*white-space:nowrap;*/
    font-weight: bold;
    position: relative;
    width: 33%;
    line-height: 18px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 .5px !important;
  }
</style>
